<span class="wrapper" [matTooltip]="tooltipText" (click)="copy()">
  <span class="text">
    {{ textToCopy }}
  </span>
  <mat-icon>content_copy</mat-icon>
</span>
